import {FormContext} from "@/components/form/Form.tsx";
import {useContext} from "react";
import {Company} from "@/types/Company";
import {cn} from "@/lib/utils.ts";
import {
    Check, FileDigit,
    Handshake,
    House,
    MessageSquareMore,
    Network, Paperclip,
    Percent,
    PersonStanding,
    ShieldUser,
    Stamp,
    LoaderCircle
} from "lucide-react";
import Field from "@/components/form/Field.tsx";

export default function Navigation({company, currentPage, setCurrentPage}: {
    company?: Company,
    currentPage: number,
    setCurrentPage: (page: number) => void
}) {
    const form = useContext(FormContext)

    const pages = [
        {
            title: "Intro",
            icon: <House size={14} color={"white"}/>
        },
        {
            title: "Találkozó",
            icon: <Handshake size={14} color={"white"}/>
        },
        {
            title: "Témák",
            icon: <MessageSquareMore size={14} color={"white"}/>
        },
        {
            title: "Cégértékelő",
            theme: "ai",
            icon: <FileDigit size={14} color={"white"}/>,
            loading: "ai_report_pending"
        },
        {
            title: "Lojalitás",
            theme: "lojalitas",
            icon: <Stamp size={14} color={"white"}/>
        },
        {
            title: "Törzsgárda",
            theme: "torzsgarda",
            icon: <ShieldUser size={14} color={"white"}/>
        },
        {
            title: "Tulajdonosi tőkeképzés",
            theme: "tokekepzes",
            icon: <Percent size={14} color={"white"}/>
        },
        {
            title: "Találkozó résztvevők",
            icon: <PersonStanding size={14} color={"white"}/>
        },
        {
            title: "Nyugdíj",
            theme: "nyugdij",
            icon: <Network size={14} color={"white"}/>
        },
        {
            title: "Csatolmányok",
            icon: <Paperclip size={14} color={"white"}/>
        }
    ]

    function getPages() {
        const themes = form.getValue("theme")
        return pages.filter((page) => {
            if (page.theme) {
                return themes?.[page.theme] ?? false
            }
            return true
        })
    }

    return (<>

        <div className={"flex flex-col gap-2 px-4 pt-1 w-full items-center"}>
            <p className={"font-bold text-2xl -mb-3"}>{company ? company.summary.details.name : "Új tanulmány"}</p>
            <p className={"h-6"}>{form.getValue("title")}</p>
            <div className={"w-full max-w-[64rem] px-8"}>
                <div className={"flex justify-between relative h-32"}>
                    <div
                        className={"absolute top-4 border border-muted-foreground transition-all w-[calc(100%-4px)] ml-[2px]"}></div>
                    <div className={"absolute top-4 border border-primary transition-all ml-[2px] duration-700"}
                         style={{width: 'calc(' + (currentPage / (getPages().length - 1) * 100) + "% - 4px)"}}></div>
                    {getPages().map((page, index) => (<>
                        <div className={"flex flex-col items-center gap-1 z-10 relative"}>
                            {
                                (page.loading) ?
                                    <Field name={page.loading}>{
                                        (field) =>
                                            field.value ?
                                                <>
                                                    <div onClick={() => setCurrentPage(index)}
                                                         className={cn("transition-all flex items-center justify-center cursor-pointer border-2 border-muted size-8 rounded bg-aiblue")}>
                                                        <LoaderCircle className={"animate-spin"} size={14}
                                                                      color="white"/>
                                                    </div>
                                                    <p className={cn("text-primary absolute top-8 text-center text-sm whitespace-wrap text-sm/3.5 mt-0.5", index > currentPage && "text-muted-foreground", index == currentPage ? "font-bold" : "")}>{page.title}</p>
                                                </>
                                                :
                                                <>
                                                    <div onClick={() => setCurrentPage(index)}
                                                         className={cn("transition-all flex items-center justify-center cursor-pointer border-2 border-muted size-8 rounded", index <= currentPage ? "bg-primary" : "bg-muted-foreground")}>
                                                        {page.icon ? page.icon : (index < currentPage &&
                                                            <Check color={"white"} size={14}/>)}
                                                    </div>
                                                    <p className={cn("text-primary absolute top-8 text-center text-sm whitespace-wrap text-sm/3.5 mt-0.5", index > currentPage && "text-muted-foreground", index == currentPage ? "font-bold" : "")}>{page.title}</p>
                                                </>
                                        }
                                    </Field>
                                    :
                                    <>
                                        <div onClick={() => setCurrentPage(index)}
                                             className={cn("transition-all flex items-center justify-center cursor-pointer border-2 border-muted size-8 rounded", index <= currentPage ? "bg-primary" : "bg-muted-foreground")}>
                                            {page.icon ? page.icon : (index < currentPage &&
                                                <Check color={"white"} size={14}/>)}
                                        </div>
                                        <p className={cn("text-primary absolute top-8 text-center text-sm whitespace-wrap text-sm/3.5 mt-0.5", index > currentPage && "text-muted-foreground", index == currentPage ? "font-bold" : "")}>{page.title}</p>
                                    </>
                            }
                        </div>
                    </>))}
                </div>

            </div>
        </div>
    </>)
}